import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useYokohamaData } from "../../../lib/useMockData";

export default function FinalCTA() {
  const { finalCTA } = useYokohamaData();
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20Yokohama%20bay%20bridge%20and%20Minato%20Mirai%20skyline%20with%20sparkling%20lights%2C%20deep%20navy%20blue%20sky%2C%20helicopter%20perspective%2C%20cinematic%20luxury%20atmosphere%2C%20wide%20panoramic%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=1920&height=700&seq=yfinalcta02&orientation=landscape"
        alt="横浜夜景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-airdoa-navy/70" />

      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold text-white leading-[1.3] whitespace-pre-line">
              {finalCTA.title}
            </h2>
            <p className="mt-5 md:mt-6 text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
              {finalCTA.subtitle}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              {finalCTA.ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link key={cta.href} to={cta.href} className="btn-primary">
                      {cta.label}
                    </Link>
                  );
                }
                return (
                  <Link key={cta.href} to={cta.href} className="btn-ghost">
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
